import axios from "axios";
import { getUrl } from "@/common/config";

export default class MachineToolingApi {
  constructor() {
    this.url = getUrl();
  }

  getMachineTooling(machineId, search) {
    //
    // Return fake
    //
    // return new Promise((resolve, reject) => {
    //  resolve(fakeMT)
    // })

    //REAL API
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/tools`, { params: search })
      .then(response => response.data);
  }

  getMachineToolingDetails(machineId, toolId) {
    //
    // Return fake
    //
    // return new Promise((resolve, reject) => {
    //  resolve(fakeMTD)
    // })

    //REAL API
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/tools/${toolId}/history`)
      .then(response => response.data);
  }

  patchTool(machineId, toolId, params) {
    return axios
      .patch(`${this.url}/api/v2/machines/${machineId}/tools/${toolId}`, params)
      .then(response => response.data);
  }

  getToolByIdAndMachineId(machineId, toolId, params) {
    return axios
      .get(`${this.url}/api/v2/machines/${machineId}/tools/${toolId}`, params)
      .then(response => response.data);
  }
}
